/**
 * El «(opcional)» junto a la etiqueta de un campo que no es obligatorio. Va
 * DENTRO del `label`/`legend`, así que forma parte del nombre accesible
 * («Edad (opcional)»); el espacio es un nodo de texto propio para que el nombre
 * no salga pegado.
 */
export function OptionalTag({ tag }: { tag?: string }) {
  if (!tag) return null
  return <> <span className="font-normal text-stone-500">{tag}</span></>
}
